// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"43":"app-theme-dark0","234":"app-theme-dark1","653":"app-theme-light0","844":"app-theme-light1"}[chunkId] + "." + {"43":"c04a8c88","234":"3dd5b92b","653":"c830126c","844":"81318b6b"}[chunkId] + ".chunk.js";
};